import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import Locatedoctor from '../../component/Locatedoctor'
// import { Map, GoogleApiWrapper } from 'google-maps-react';
import { BrowserRouter as Router, Switch, Route, HashRouter } from "react-router-dom"
import Maplist from '../../component/Map'
import {
  Container, Row, Col
} from "reactstrap"
import Header from "../../component/Header";
import { FullWrap, Heading, SubHeading, MapWrap, InnerWrap, ResultWrap, ResultHeading, ResultCard, CardTopWrap, CardLink, CardInnerHeading, CardFooter, CallButton, VisitButton, PdfButton } from "./styles";
import Footer from "../../component/Footer";
import GoogleMapReact from 'google-map-react';
import { getDoctorLocation } from '../../doctorapi'
import { toast } from "react-toastify"
import { PDFExport } from '@progress/kendo-react-pdf';
import get from 'lodash/get'

// const AnyReactComponent = ({ text }) => <div>{text}</div>;
const User = (props) => {
  const [center, setCenter] = useState({ lat: 30, lng: -70 });
  const [zoom, setZoom] = useState(1);
  const [mapListingValues, setMapListingValues] = useState([])
  const [isCheckData, setIsCheckData] = useState(false)
  const [getMiles, setGetMiles] = useState()
  const [zipCodeValue, setZipCodeValue] = useState()
  const [productTypes, setProductTypes] = useState(['Axonics SNM'])
  const [isLoading, setIsLoading] = useState(false)
  toast.configure()

  let pdfExportComponent

  let zoomData = [{
    "zoom": 15,
    "miles": 16090
  },
  {
    "zoom": 11,
    "miles": 40225
  },
  {
    "zoom": 10,
    "miles": 80450
  },
  {
    "zoom": 9,
    "miles": 160900
  },
  {
    "zoom": 7,
    "miles": 321800
  },
  {
    "zoom": 5,
    "miles": 804500
  }]

  // useEffect(() => {
  //   handleMapListing({miles:40225});
  // }, [])
  const handleMapListing = (searchValues) => {
    setIsLoading(true)
    let filterdata = zoomData.filter(item =>
      item.miles === searchValues.miles
    )
    if(searchValues.miles){
      setGetMiles(filterdata[0]);
      setZoom(filterdata[0].zoom);
    }
    searchValues['productTypes'] = productTypes
    getDoctorLocation(searchValues).then(response => {
      setIsLoading(false)
      if (response.data.body.length) {
        setCenter({ lat: response.data.body[0].latLong[1], lng: response.data.body[0].latLong[0] })

        let searchedZipArray=response.data.body && response.data.body.length &&response.data.body.filter(item=>item.zip==zipCodeValue);
         let nonZipArray = response.data.body && response.data.body.length &&response.data.body.filter(item=>item.zip!==zipCodeValue);
        setMapListingValues([...searchedZipArray,...nonZipArray])
        setIsCheckData(true);
        notify("success")
      } else {
        setZoom(1)
        setCenter({ lat: 30, lng: -70 })
        setIsCheckData(false)
        notify("dataerror")
      }
    }).catch(err => {
      setIsLoading(false)
      setZoom(1)
      setCenter({ lat: 30, lng: -70 })
      notify("error")
      setIsCheckData(false)
    })
  }
  const notify = msg => {
    if (msg == "error") {
      toast.error("Internal Server Error")
    } else if (msg == "dataerror") {
      toast.success("No Data Found")
    } else if (msg == "success") {
      toast.success("Data Found Successfully")
    }
  }
  const options = {
    orientation: 'landscape',
    unit: 'in',
    // format: [4,2]
  };

  return (
    <div>
      <FullWrap>
        <Header />
        <InnerWrap>
          <Container>
            <Heading>Find Axonics Provider</Heading>
            {isCheckData ? (
              <div className="example-config">
                <CallButton style={{ cursor: "pointer" }} className="k-button" onClick={() => { pdfExportComponent.save() }}>
                  Doctors PDF
                    </CallButton>
              </div>) : (null)}


            <Locatedoctor handleMapListing={handleMapListing}
              setZipCodeValue={setZipCodeValue}
              setProductTypes={setProductTypes}
              productTypes={productTypes}
                          isLoading={isLoading}
            />


            <Maplist isCheckData={isCheckData}
              mapListingValues={mapListingValues}
              center={center}
              zoom={zoom} />
            {isCheckData ? (
              <PDFExport
                forcePageBreak=".page-break"
                ref={(component) => { pdfExportComponent = component }}
              >
                <div>
                  {/* {mapListingValues && mapListingValues.length && mapListingValues.map((places, index) => {
                    return !index ? (
                      <div>
                      <Maplist isCheckData={isCheckData}
                      mapListingValues={mapListingValues}
                      center={center}
                      zoom={zoom} />
                      </div>
                      ) : null
                    })} */}
                  <Heading>Axonics Provider</Heading>
                  {isCheckData ? (
                    <ResultWrap>{isCheckData ? (
                      <ResultHeading style={{ color: "black", paddingLeft: "5px" }}>  {mapListingValues.length} Doctors found in {getMiles && getMiles.miles ? getMiles.miles / 1609 : 0}  miles of zipcode <span style={{ paddingLeft: "5px" }}>{zipCodeValue}</span> </ResultHeading>) : (
                        <ResultHeading>No result</ResultHeading>
                      )}
                      {mapListingValues && mapListingValues.length && mapListingValues.map(places => {
                        return (
                          <ResultCard>
                            <CardTopWrap>
                              <Row>
                                <Col lg="4">
                                  <CardInnerHeading style={{ fontWeight: "700" }}>Full Name</CardInnerHeading>
                                  <CardInnerHeading>{`Dr. ${get(places, 'firstName', '')} ${get(places,'lastName', '')}`}</CardInnerHeading>
                                </Col>
                                <Col lg="4">
                                  <CardInnerHeading style={{ fontWeight: "700" }}>Practice Name</CardInnerHeading>
                                  <CardInnerHeading>{places.centerName}</CardInnerHeading>
                                </Col>
                                <Col lg="4">
                                  <CardInnerHeading style={{ fontWeight: "700" }}>Address</CardInnerHeading>
                                  <CardInnerHeading>{`${get(places,'Address', '')} - ${get(places, 'zip', '')}`}</CardInnerHeading>
                                </Col>
                              </Row>
                            </CardTopWrap>
                            <CardFooter>
                              <Row>
                                <Col md="6" lg="4">
                                  <CardInnerHeading style={{ fontWeight: "700" }}>Phone Number</CardInnerHeading>
                                  <CardInnerHeading>{places.phone}</CardInnerHeading>
                                </Col>
                                <Col xs="6" lg="4">
                                  <CardInnerHeading style={{ fontWeight: "700" }}>Website</CardInnerHeading>
                                  <a href={"http://" + places.websiteURL}>{places.websiteURL}</a>
                                </Col>
                                <Col xs="6" lg="4">
                                  <CardInnerHeading style={{ fontWeight: "700" }}>Distance (in miles)</CardInnerHeading>
                                  <CardInnerHeading>{((places.distance || 0) / 1609).toFixed(2)} Miles</CardInnerHeading>
                                </Col>
                                <Col xs="6" lg="4">
                                  <CardInnerHeading style={{ fontWeight: "700" }}>Specialities</CardInnerHeading>
                                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                                    {places.speciality && <CardInnerHeading>{places.speciality && places.speciality.toLowerCase()=='other' ? places.otherSpeciality : places.speciality}</CardInnerHeading>}
                                  </div>
                                </Col>
                                <Col xs="6" lg="4">
                                  <CardInnerHeading style={{ fontWeight: "700" }}>Treat (Patient's Age)</CardInnerHeading>
                                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                                    <CardInnerHeading>{places.iTreatPatient && places.iTreatPatient.length ? places.iTreatPatient.join(', ') : null }</CardInnerHeading>
                                  </div>
                                </Col>
                                <Col xs="6" lg="4">
                                  <CardInnerHeading style={{ fontWeight: "700" }}>Treat (Patient's Gender)</CardInnerHeading>
                                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                                    {places.iTreat && places.iTreat.length ? places.iTreat.map((item, i) => <CardInnerHeading>{item}{i == places.iTreat.length - 1 ? null : ', '}</CardInnerHeading>) : null}
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col xs="6" lg="4">
                                  <CardInnerHeading style={{ fontWeight: "700" }}>Center of Excellence</CardInnerHeading>
                                  <CardInnerHeading>{typeof places.centerOfExcellence === 'boolean' ? places.centerOfExcellence ? 'Yes' : 'No' : ''}</CardInnerHeading>
                                </Col>
                                <Col xs="6" lg="4">
                                  <CardInnerHeading style={{ fontWeight: "700" }}>Products Used</CardInnerHeading>
                                  <CardInnerHeading>{places.productTypes && places.productTypes.join(', ')}</CardInnerHeading>
                                </Col>
                              </Row>
                            </CardFooter>
                          </ResultCard>
                        )
                      })}
                    </ResultWrap>) : (<p>
                      NO Result
                    </p>)}
                </div>
              </PDFExport>) : (null)}

            {/* {mapListingValues && mapListingValues.length ? null : (
              <Maplist isCheckData={isCheckData}
                mapListingValues={mapListingValues}
                center={center}
                zoom={zoom} />)} */}


            {/* <Maplist isCheckData={isCheckData}
              mapListingValues={mapListingValues}
              center={center}
              zoom={zoom} /> */}



          </Container>
        </InnerWrap>
      </FullWrap >
      <Footer />
    </div>
  )
}

export default User





// WEBPACK FOOTER //
// ./src/views/User/index.js